var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"k-chk",class:{checked: _vm.checked === true},attrs:{"href":"javascript:;","title":_vm.title || '',"r-eid":("k-chk-" + _vm.name)},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }